import { Component } from 'react';

/**
 * ErrorBoundary — catches React render errors so the whole app
 * doesn't go blank. Shows a friendly recovery screen instead.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(160deg, #fafbfc 0%, #f0f7f6 100%)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '24px',
      }}>
        <div style={{ textAlign: 'center', maxWidth: '340px' }}>
          <div style={{ fontSize: '2.5rem', marginBottom: '16px' }}>🌿</div>
          <h2 style={{
            fontFamily: "'Playfair Display', serif",
            color: '#1E6B68', fontSize: '1.4rem', fontWeight: '400',
            margin: '0 0 12px',
          }}>
            Something interrupted the practice
          </h2>
          <p style={{ color: '#999', fontSize: '0.9rem', lineHeight: 1.7, margin: '0 0 28px' }}>
            An unexpected error occurred. Your data is safe — refreshing the page will restore everything.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '14px 32px',
              background: 'linear-gradient(135deg, #1E6B68 0%, #2D8B87 100%)',
              color: '#fff', border: 'none', borderRadius: '50px',
              fontSize: '0.95rem', fontWeight: '600', cursor: 'pointer',
              boxShadow: '0 4px 16px rgba(30,107,104,0.25)',
            }}
          >
            Refresh
          </button>
          {process.env.NODE_ENV === 'development' && (
            <details style={{ marginTop: '24px', textAlign: 'left' }}>
              <summary style={{ color: '#bbb', fontSize: '0.75rem', cursor: 'pointer' }}>
                Error details (dev only)
              </summary>
              <pre style={{ fontSize: '0.7rem', color: '#D9534F', whiteSpace: 'pre-wrap', marginTop: '8px' }}>
                {this.state.error?.toString()}
              </pre>
            </details>
          )}
        </div>
      </div>
    );
  }
}
